<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="isallowed">
            <!-- search code shiv -->

            <!-- search code end shiv -->
            <v-data-table :headers="headers" :items="bookList1" class="elevation-1 mytable" denses :search="search" @current-items="getFiltered"  :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>Serial Field Tracking</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details style="margin-top: 20px;"> </v-text-field>
                        </v-col>
                        <!-- ss -->
                        <template>
                            <v-row justify="center" align="center" style="margin-top: 10px;">
                                <tr class="t-row">
                                    <div>
                                        <th>
                                            <v-row>
                                                <span v-for="header in headers" :key="header.text">
                                                    <span v-if="filters.hasOwnProperty(header.value)">
                                                        <v-autocomplete
                                                            class="mr-2 pb-5 pt-2"
                                                            flat
                                                            hide-details
                                                            small
                                                            rounded
                                                            dense
                                                            outlined
                                                            color="#0F2027"
                                                            :label="header.text"
                                                            multiple
                                                            clearable
                                                            :items="columnValueList(header.value)"
                                                            v-model="filters[header.value]"
                                                        ></v-autocomplete>
                                                    </span>
                                                </span>
                                            </v-row>
                                        </th>
                                    </div>
                                </tr>
                            </v-row>
                        </template>
                        <!-- ss -->
                        <!-- <span style="width: 20px"></span> -->
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="button1" v-on="on" small>Add Serial Field Tracking</v-btn>
                            </template>

                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.track" persistent-hint hint="1, 2, 3,..." label="Track No." :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.prefixvalue" persistent-hint hint="vvp" label="prefix."></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete
                                                        :items="sf_type_list"
                                                        v-model="editedItem.serialfieldtype_id"
                                                        item-text="serialfieldtype"
                                                        item-value="sft_id"
                                                        label="Select Serial Field Type"
                                                        :disabled="editedIndex != -1"
                                                        :rules="[(v) => !!v || 'required']"
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete
                                                        :items="sf_master_list"
                                                        v-model="editedItem.serialfieldmaster_id"
                                                        item-text="serialfieldmaster"
                                                        item-value="sfm_id"
                                                        label="Select Serial Field Master"
                                                        :disabled="editedIndex != -1"
                                                        :rules="[(v) => !!v || 'required']"
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete
                                                        :items="ay_list"
                                                        v-model="editedItem.academicyear_id"
                                                        item-text="academicyear"
                                                        item-value="ay_id"
                                                        label="Select Academic Year"
                                                        :rules="[(v) => !!v || 'required']"
                                                    ></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete :items="section_list" v-model="editedItem.section" item-text="name" item-value="editedItem.section" label="Select Section" v-if="editedIndex != -1"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-autocomplete :items="section_list" v-model="editedItem.section" item-text="name" item-value="id" label="Select Section" v-if="editedIndex == -1"></v-autocomplete>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <!-- shiv code -->
                <!-- <template  class="pb-5">
            <v-row justify="center" align="center">
              <tr class="t-row">
                <div>
                  <th>
                    <v-row>
                      <span v-for="header in headers" :key="header.text">
                        <span v-if="filters.hasOwnProperty(header.value)">
                          <v-autocomplete
                            class="mr-2 pb-5 pt-2"
                            flat
                            hide-details
                            small
                            rounded
                            dense
                            outlined
                            color="#0F2027"
                            :label="header.text"
                            multiple
                            clearable
                            :items="columnValueList(header.value)"
                            v-model="filters[header.value]"
                          ></v-autocomplete>
                        </span>
                      </span>
                    </v-row>
                  </th>
                </div>
              </tr>
            </v-row>
          </template> -->
                <!-- end -->
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data: () => ({
            valid: false,
            filterArr: [],

            filters: {
                academicyear: [],
                serialfieldtype: [],
            },
            sft_list: "",
            overlay: false,
            errorMsg: {
                track: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            dialog: false,
            //   quota_super_master_list:null,
            displayname: "",
            section_list: [],
            headers: [
                {
                    text: "Sr No.",
                    align: "left",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Track No",
                    align: "left",
                    sortable: false,
                    value: "track",
                },
                {
                    text: "Prefix",
                    align: "left",
                    sortable: false,
                    value: "prefixvalue",
                },
                {
                    text: "Serial Field Type",
                    align: "left",
                    sortable: false,
                    value: "serialfieldtype",
                },
                {
                    text: "Serial Field Master",
                    align: "left",
                    sortable: false,
                    value: "serialfieldmaster",
                },
                {
                    text: "Academic Year",
                    align: "left",
                    sortable: false,
                    value: "academicyear",
                },
                {
                    text: "Section",
                    align: "left",
                    sortable: false,
                    value: "section",
                },

                { text: "Actions", value: "action", sortable: false },
            ],
            sft_list: [],
            sf_type_list: [],
            sf_master_list: [],
            ay_list: [],
            editedIndex: -1,
            editedItem: {
                id: "",
                track: "",
                serialfieldtype_id: "",
                academicyear_id: "",
                serialfieldmaster_id: "",
                section: null,
                prefixvalue:"",
            },
            defaultItem: {
                id: "",
                track: "",
                serialfieldtype_id: "",
                academicyear_id: "",
                serialfieldmaster_id: "",
                section: null,
                prefixvalue:"",
            },
            section_list: [],
            isallowed:false,
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Serial Field Tracking" : "Edit Serial Field Tracking";
            },
            bookList1() {
                return this.sft_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },

        // created () {
        //   this.initialize()
        // },
        mounted() {
            this.onLoad();
        },
        methods: {
            //   initialize () {

            //   },

            getFiltered(e) {
                this.filterArr = e;
            },

            columnValueList(val) {
                return this.sft_list.map((d) => d[val]);
            },
            editItem(item) {
                this.editedIndex = this.sft_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/AdmissionMaster/serialFieldTrackingMasterHome")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.overlay = false;
                            this.isallowed = res.data.isallowed;
                            this.sft_list = res.data.sft_list;
                            this.sf_type_list = res.data.sf_type_list;
                            this.sf_master_list = res.data.sf_master_list;
                            this.ay_list = res.data.ay_list;
                            this.section_list = res.data.section_list;
                        } else if (res.data.flag == "No") {
                            this.isallowed = res.data.isallowed;
                            this.showSnackbar("red", res.data.snackbar)
                            this.load = false
                        }else {
                            window.console.log(res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        "use strict";
                        var overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        axios
                            .post("/AdmissionMaster/editSerialFieldTrackingMaster", this.editedItem)
                            .then((res) => {
                                if (res.data.status == "YES") {
                                    //window.alert(res.data.msg)
                                    Object.assign(this.sft_list[this.editedIndex], this.editedItem);
                                    this.showSnackbar("#4caf50", "Serial Field Track Updated Successfully..."); // show snackbar on success
                                } else if (res.data.status == "NA") {
                                    this.showSnackbar("#b71c1c", "Serial Field Track Already Present!!!"); // show snackbar on error
                                }
                                else {
                                    this.showSnackbar("#b71c1c", "Record cannot be updated, please try again!...");
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });
                        this.close();
                    }
                } else {
                    //this.quota_master_list.push(this.editedItem)
                    axios
                        .post("/AdmissionMaster/saveSerialFieldTrackingMaster", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                //window.alert(res.data.status.code)
                                this.sft_list.push(this.editedItem);
                                this.showSnackbar("#4caf50", "New Serial Field Track Added Successfully!!!"); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                //window.alert(res.data.status.code)
                                //alert(res.data.status.message)
                                this.showSnackbar("#b71c1c", "Serial Field Track Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            }, //save()

            isValidated() {
                if (this.editedItem.track) {
                    return true;
                } else {
                    if (!this.editedItem.track) {
                        this.errorMsg.track = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }

    .button1 {
        margin-right: 10px;
        margin-bottom: 10px;
        border-radius: 10px;
        border: 2px solid;
    }
</style>
